import { clsx } from 'clsx';
import classes from './Popover.module.css.js';
import React from 'react';
import { toggleSxComponent } from '../internal/utils/toggleSxComponent.js';
import { jsx } from 'react/jsx-runtime';

const PopoverBaseComponent = toggleSxComponent('div');
const Popover = /*#__PURE__*/React.forwardRef(function Popover({
  className,
  caret = 'top',
  open,
  relative,
  ...props
}, forwardRef) {
  return /*#__PURE__*/jsx(PopoverBaseComponent, {
    ...props,
    ref: forwardRef,
    "data-open": open ? '' : undefined,
    "data-relative": relative ? '' : undefined,
    "data-caret": caret,
    className: clsx(className, classes.Popover)
  });
});
Popover.displayName = 'Popover';
const PopoverContentBaseComponent = toggleSxComponent('div');
const PopoverContent = ({
  className,
  ...props
}) => {
  return /*#__PURE__*/jsx(PopoverContentBaseComponent, {
    ...props,
    className: clsx(className, classes.PopoverContent)
  });
};
PopoverContent.displayName = "PopoverContent";
PopoverContent.displayName = 'Popover.Content';
var Popover$1 = Object.assign(Popover, {
  Content: PopoverContent
});

export { Popover$1 as default };
